module.exports = __webpack_public_path__ + "img/ru_failure_5.1b360dde.png";